// ONE rule for "this route is not applied on the server yet": an UNCODED 404. A coded 404 (CUSTOMER_NOT_FOUND ...) is a real answer from a served route.
export const isMissingRoute = (r) => !!r && r.status === 404 && !(r.data && r.data.code);
